export default {
  报价管理: "ราคาเชิญ",
  样品管理: "ตัวอย่าง",
  脚本审核: "ตรวจสอบสคริปต์",
  草稿审核: "ตรวจสอบสคริปต์",
  交付内容: "ส่งมอบสินค้า",
  打款信息: "ข้อมูลการรับเงิน",
  商单PM: "PM แคมเปญ",
  "复制成功！": "คัดลอกเรียบร้อย!",
  "商单已交付或已取消，不可操作，已为您刷新页面！": "แคมเปญถูกส่งหรือยกเลิกแล้ว รีเฟรชหน้าให้แล้ว",
  达人要求: "ความต้องการของครีเอเตอร์",
  粉丝量: "ผู้ติดตาม",
  目标接单达人数: "จำนวนครีเอเตอร์ที่รับงาน",
  "平均预算/达人": "ราคาเฉลี่ย/ครีเอเตอร์",
  目标总预算: "งบประมาณรวม",
  邀约达人时间: "เวลาเชิญครีเอเตอร์",
  目标交付时间: "เวลาส่งมอบ",
  查看详情: "ดูรายละเอียด",
  邀约中: "กำลังเชิญ",
  已接单: "รับงานแล้ว",
  已取消: "ยกเลิกแล้ว",
  达人唯一名: "ชื่อครีเอเตอร์ที่ไม่ซ้ำ",
  达人昵称: "ชื่อครีเอเตอร์",
  达人: "ครีเอเตอร์",
  粉丝数: "ผู้ติดตาม",
  邀约报价: "ราคาเชิญ",
  操作: "การดำเนินการ",
  修改报价: "แก้ไขราคา",
  复制邀请链接: "คัดลอกลิงก์เชิญ",
  取消邀约: "ยกเลิกการเชิญ",
  新增邀约达人: "เพิ่มครีเอเตอร์",
  邀约达人: "เชิญครีเอเตอร์",
  已邀约达人不可重复添加: "ไม่สามารถเพิ่มครีเอเตอร์ซ้ำ",
  请输入TikTok账号唯一名: "กรุณาใส่ชื่อบัญชี TikTok",
  请输入金额: "กรุณากรอกจำนวนเงิน",
  修改后达人的商单邀请将同步更新: "การแก้ไขจะอัปเดตคำเชิญโดยอัตโนมัติ",
  请输入取消邀约理由: "กรุณาระบุเหตุผลที่ยกเลิก",
  "最多可输入100个字，请简短说说为什么。": "ไม่เกิน 100 ตัวอักษร",
  "取消成功！": "ยกเลิกเรียบร้อย",
  "修改成功！": "แก้ไขเรียบร้อย",
  "添加成功！": "เพิ่มเรียบร้อย",
  "达人已申请样品，不可取消接单！": "ครีเอเตอร์ขอตัวอย่างแล้ว ไม่สามารถยกเลิก",
  导出数据: "ส่งออกข้อมูล",
  接单达人: "ครีเอเตอร์ที่รับงานแล้ว",
  选择操作: "เลือกการดำเนินการ",
  修改最终报价: "แก้ไขราคาไฟนอล",
  取消接单: "ยกเลิกการรับงาน",
  新增接单达人: "เพิ่มครีเอเตอร์ที่รับงาน",
  已接单达人不可重复添加: "ไม่สามารถเพิ่มครีเอเตอร์ซ้ำ",
  "该达人已接单您的邀请，请勿重复添加！": "ครีเอเตอร์รับคำเชิญแล้ว",
  接单报价: "ราคารับงาน",
  "请和达人确认后修改，否则由PIC自行承担责任！": "โปรดยืนยันกับครีเอเตอร์ก่อนแก้ไข",
  最终报价: "ราคาสุดท้าย",
  请输入取消接单理由: "กรุณาระบุเหตุผลยกเลิก",
  接单时间: "เวลารับงาน",
  取消时间: "เวลายกเลิก",
  取消理由: "เหตุผลการยกเลิก",
  "自动取消，已被其他PIC谈成！": "ยกเลิกอัตโนมัติ มี PIC อื่นตกลงแล้ว",
  商单已交付: "ส่งแคมเปญแล้ว",
  待申样: "รอขอตัวอย่าง",
  已申样: "ขอตัวอย่างแล้ว",
  申请样品: "ขอสินค้าตัวอย่าง",
  商单: "แคมเปญ",
  新建样品订单: "สร้างออเดอร์ตัวอย่างใหม่",
  报价: "ราคา",
  申样达人名称: "ชื่อครีเอเตอร์",
  可履约方式: "วิธีการดำเนินการ",
  "该达人粉丝数＜20K": "ครีเอเตอร์มีผู้ติดตามน้อยกว่า 20K",
  收件人姓名: "ชื่อผู้รับ",
  收件人电话: "เบอร์โทรศัพท์ผู้รับ",
  地区: "พื้นที่",
  详细地址: "รายละเอียดที่อยู่",
  "请输入街道名称，公寓名称，房间号": "กรุณากรอกชื่อถนน อาคาร ห้อง",
  商单商品: "สินค้าแคมเปญ",
  商品ID: "รหัสสินค้า",
  添加规格: "เพิ่มสเปค",
  规格: "สเปค",
  数量: "จำนวน",
  请输入有效的手机号: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
  申样数量: "จำนวนตัวอย่างที่ขอ",
  样品详情: "รายละเอียดตัวอย่าง",
  追加申样: "ขอเพิ่มตัวอย่าง",
  待审核: "รอตรวจสอบ",
  待发货: "รอจัดส่ง",
  待履约: "รอการดำเนินการ",
  已拒绝: "ถูกปฏิเสธ",
  合格: "ผ่าน",
  不合格: "ไม่ผ่าน",
  待上传: "รออัปโหลด",
  待收款: "รอรับเงิน",
  已收款: "รับเงินแล้ว",
  交付视频: "ส่งวิดีโอ",
  标题: "ชื่อวิดีโอ",
  Hashtag达标: "แฮชแท็กถูกต้อง",
  挂链正确: "ลิงก์สินค้าแนบถูกต้อง",
  时长达标: "ความยาววิดีโอถูกต้อง",
  "Ads Code": "Ads Code",
  播放量: "จำนวนการรับชม",
  "销量（TAP link）": "ยอดขาย（ลิงก์สินค้า）",
  校验人: "ผู้ตรวจสอบ",
  系统自动: "系统自动",
  人工校验: "ตรวจสอบด้วยคน",
  其他理由: "เหตุผลอื่น",
  确认合格: "ยืนยันว่าผ่าน",
  重新上传: "อัปโหลดใหม่",
  确认商单商品合格: "ยืนยันว่าคอนเทนต์ผ่าน",
  "请勾选以下要求，人工确认已合格": "ยืนยันรายการตรวจสอบก่อนการอนุมัติ",
  Hashtag: "แฮชแท็ก",
  "TAP link": "ลิงก์สินค้า",
  视频时长: "ความยาววิดีโอ",
  交付视频合格: "วิดีโอผ่านเกณฑ์",
  "该视频将标记为合格视频，你还要继续吗？":
    '<span style="color: red">วิดีโอนี้จะถูกทำเครื่องหมายว่าผ่าน</span> คุณต้องการดำเนินการต่อหรือไม่?',
  "请勾选以理由，将在APP展示给达人": "เลือกเหตุผลที่จะโชว์ให้ครีเอเตอร์ทราบในแอป",
  Hashtag错误: "แฮชแท็กผิด",
  "TAP link未挂链": "ลิงก์สินค้าไม่แนบ",
  视频时长未达标: "ความยาววิดีโอไม่ผ่าน",
  "Ads Code未填或填写错误": "รหัสโฆษณาไม่กรอกหรือผิด",
  不超过20个字: "ไม่เกิน 20 ตัวอักษร",
  不合格理由: "เหตุผลที่ไม่ผ่าน",
  "请输入该视频的Ads Code": "กรุณากรอก รหัสโฆษณา",
  仅展示信息有误: "ข้อมูลผิดพลาดเท่านั้น",
  履约状态: "สถานะการดำเนินการ",
  已交付: "ส่งมอบแล้ว",
  应付商单费用: "ค่าจ้างแคมเปญที่ต้องจ่าย",
  收款类型: "ประเภทการชำระเงิน",
  未上传: "ยังไม่อัปโหลด",
  信息有误: "ข้อมูลไม่ถูกต้อง",
  个人: "บุคคลธรรมดา",
  公司: "บริษัท",
  银行信息: "ข้อมูลบัญชีธนาคาร",
  收款人: "ผู้รับเงิน",
  收款银行: "ธนาคาร",
  收款卡号: "เลขบัญชีธนาคาร",
  查看凭证: "ดูหลักฐาน",
  手机号: "เบอร์โทรศัพท์",
  身份证信息: "ข้อมูลบัตรประชาชน",
  姓名: "ชื่อ",
  性别: "เพศ",
  称呼: "คำนำหน้า",
  身份证号: "หมายเลขบัตรประชาชน",
  身份证居住地址: "ที่อยู่ตามทะเบียนบ้าน",
  营业执照: "ใบอนุญาตประกอบธุรกิจ",
  添加收款信息: "เพิ่มข้อมูลการรับเงิน",
  编辑收款信息: "แก้ไขข้อมูลการรับเงิน",
  "必填项未填！": "กรุณากรอกข้อมูลให้ครบถ้วน",
  个人收款: "บุคคล",
  公司收款: "บริษัท",
  收款信息: "ข้อมูลการชำระเงิน",
  联系电话: "เบอร์โทรติดต่อ",
  收款人性别: "เพศผู้รับเงิน",
  小姐: "นางสาว",
  女士: "นาง",
  先生: "นาย",
  身份证姓名: "ชื่อในบัตรประชาชน",
  请输入身份证居住地址: "ที่อยู่ในบัตรประชาชน",
  身份证号码: "เลขบัตรประชาชน",
  银行卡号: "หมายเลขบัญชี",
  身份证照片: "รูปบัตรประชาชน",
  银行信息截图: "ภาพข้อมูลบัญชีธนาคาร",
  确认通过: "ยืนยันการอนุมัติ",
  "确认收款信息无误可以打款，你还要继续吗？":
    '<span style="color: red">ข้อมูลถูกต้องสามารถโอนเงินได้</span>ต้องการดำเนินการต่อหรือไม่?',
  收款信息有误: "ข้อมูลการรับเงินผิด",
  "请填写理由，将在APP展示给达人": "กรุณาใส่เหตุผลที่จะโชว์ในแอปให้ครีเอเตอร์",
  不超过50个字: "ไม่เกิน 50 ตัวอักษร",
  银行信息凭证: "หลักฐานข้อมูลบัญชีธนาคาร",
  银行凭证: "หลักฐานข้อมูลบัญชีธนาคาร",
  关闭: "ปิด",
  保存: "บันทึก",
  居住地址: "ที่อยู่ที่พักอาศัย",
  "该信息已审核通过或已打款，不可保存修改内容": "ข้อมูลถูกต้องสามารถโอนเงินได้",
  营业执照凭证: "หลักฐานข้อมูลบริษัท",
  收款信息审核人: "ผู้ตรวจสอบข้อมูล",
  导入数据: "นำเข้าข้อมูล",
  确认打款: "ยืนยันการโอนเงิน",
  请输入打款时间: "กรุณากรอกเวลาการโอนเงิน",
  打款时间: "เวลาโอนเงิน",
  打款类型: "ประเภทการโอนเงิน",
  打款操作人: "ผู้ดำเนินการโอนเงิน",
  通过: "ผ่าน",
  已打款: "โอนเงินแล้ว",
  系统审核中: "กำลังตรวจสอบข้อมูล",
  身份证凭证: "หลักฐานข้อมูลบัตรประชาชน",
  修改收款信息: "แก้ไขข้อมูลการรับเงิน",
  公司营业执照: "ใบอนุญาตบริษัท",
  收款人称呼: "คำนำหน้าผู้รับเงิน",
  进行中: "กำลังดำเนินการ",
  "申样成功，请前往样品申样查看！": "ขอตัวอย่างสำเร็จ กรุณาตรวจสอบในหน้าขอตัวอย่าง",
  前往样品申样: "กรุณาตรวจสอบในหน้าขอตัวอย่าง",
  "操作成功！": "ดำเนินการสำเร็จ",
  请勾选所有要求: "กรุณาเลือกทุกรายการ",
  必需: "จำเป็น",
  非必需: "ไม่จำเป็น",
  商单报价: "ราคาแคมเปญ",
  VAT: "VAT",
  商单总价: "ราคารวมแคมเปญ",
  含VAT: "รวมภาษี",
  WHT: "WHT",
  代扣税额: "ภาษีที่ถูกหัก",
  应打款金额: "จำนวนเงินที่ต้องโอน",
  "Net Pay": "จำนวนเงินที่ต้องโอน",
  含税: "รวมภาษี",
  请输入有效的银行卡号: "กรุณากรอกหมายเลขบัญชีธนาคารที่ถูกต้อง",
  请输入有效的身份证号: "กรุณากรอกหมายเลขบัตรประชาชนที่ถูกต้อง",
  已完成: "สำเร็จ",
  待打款: "รอโอนเงิน",
  总订单数: "จำนวนสั่งซื้อ",
  请人工校验: "กรุณาตรวจสอบด้วยตนเอง",
  刷新: "รีเฟรช",
  成功商品数: "จำนวนสินค้าที่สำเร็จ",
  失败商品数: "จำนวนสินค้าที่ล้มเหลว",
  个税: "ภาษีรายได้",
  "不可打款-未履约": "ไม่สามารถจ่ายได้ - ยังไม่ส่งงาน",
  "可打款-已履约": "สามารถจ่ายได้ - ส่งงานแล้ว"
};
